import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { GraduationCap, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="h-9 w-9 rounded-lg bg-[#0A192F] flex items-center justify-center"><GraduationCap className="h-5 w-5 text-amber-500" /></div>
          <span className="font-heading font-bold text-[#0A192F]">Insurance License Lab</span>
        </Link>

        {sent ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-8 text-center" data-testid="forgot-sent">
            <div className="h-14 w-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4"><MailCheck className="h-7 w-7 text-emerald-600" /></div>
            <h2 className="font-heading text-xl font-bold text-[#0A192F]">Check your email</h2>
            <p className="text-sm text-slate-500 mt-2">If an account exists for <span className="font-medium text-[#0A192F]">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.</p>
            <Link to="/login"><Button variant="outline" className="mt-6 w-full">Back to log in</Button></Link>
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-slate-200 p-8">
            <h2 className="font-heading text-2xl font-bold text-[#0A192F]">Forgot your password?</h2>
            <p className="text-sm text-slate-500 mt-1">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-amber-600 hover:bg-amber-700 text-white h-11" data-testid="forgot-submit-btn">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-[#0A192F]"><ArrowLeft className="h-4 w-4" /> Back to log in</Link>
          </div>
        )}
      </div>
    </div>
  );
}
